import { useProperties } from '@/api/hooks';
import { Select } from '@/components/ui/Select';
import { usePropertyScope } from '@/contexts/PropertyContext';
import { cn } from '@/lib/cn';
import { MapPin } from 'lucide-react';
import { useEffect } from 'react';

export function PropertySelector({ className }: { className?: string }) {
  const { data, isLoading } = useProperties();
  const { propertyId, setPropertyId, selectFromList } = usePropertyScope();

  useEffect(() => {
    if (data?.properties) selectFromList(data.properties);
  }, [data?.properties, selectFromList]);

  if (isLoading) {
    return (
      <div className={className}>
        <div className="h-10 rounded-xl bg-manejai-sand/50 animate-pulse" />
      </div>
    );
  }

  const properties = data?.properties ?? [];

  return (
    <div className={cn('relative', className)}>
      <MapPin
        className="pointer-events-none absolute left-3 top-1/2 z-10 h-4 w-4 -translate-y-1/2 text-manejai-moss"
        aria-hidden
      />
      <Select
        className="pl-9"
        label=""
        value={propertyId ?? ''}
        onChange={(e) => setPropertyId(e.target.value ? Number(e.target.value) : null)}
        options={properties.map((p) => ({ value: p.id, label: p.name }))}
        placeholder={properties.length ? 'Selecione…' : 'Nenhuma fazenda'}
      />
    </div>
  );
}
